import React from 'react';
import { create as createBraintreeDropIn, Dropin } from 'braintree-web-drop-in';
import { BRAINTREE_DROP_IN_UI_PROPS } from '../../../constants/payment';
import styled from 'styled-components';
import { isMobile } from 'react-device-detect';
import { compose } from 'recompose';
import { graphql } from 'react-apollo';
import { OptionProps } from '@apollo/react-hoc/lib/types';
import { WhiteBackgroundLoading } from '../../../constants/styled';
import { USER_PAYMENT_TOKEN } from '../../../constants/gql/payment';
import { FormStatus } from '../../FormStatus';

const DropInContainer = styled.div`
  width: 100%;
  height: 100%;
  font-size: 16px;
  line-height: 19px;
  letter-spacing: 0.03em;
  font-family: ${(props) => props.theme.fonts.regular};
  color: ${(props) => props.theme.colors.regent};
`;

const DropInComponent = styled.div`
  overflow: ${isMobile ? 'auto' : 'hidden'};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: ${isMobile ? '100%' : '500px'};
  min-height: ${isMobile ? '100%' : '300px'};
  font-size: ${isMobile ? '12px' : '16px'};
`;

const CustomDropIn: React.FunctionComponent<IProps> = ({
  token,
  setDropInInstance,
  dropInInstance,
  errorMessage,
}) => {
  if (!token) {
    return <WhiteBackgroundLoading />;
  }
  if (!dropInInstance) {
    createBraintreeDropIn(
      BRAINTREE_DROP_IN_UI_PROPS(token),
      (error: Error | null, dropin: Dropin | undefined) => {
        if (error && !dropin && !dropInInstance) {
          console.error(error.message);
        }
        if (dropin) {
          setDropInInstance(dropin);
        }
      },
    );
  }
  return (
    <DropInComponent>
      <DropInContainer id="dropin-container" />
      <FormStatus failureMessage={errorMessage} />
    </DropInComponent>
  );
};

export default compose<IInnerProps, IOuterProps>(
  graphql(USER_PAYMENT_TOKEN, {
    props: ({ data }: OptionProps<IProps>) => ({
      token: data.paymentToken,
    }),
  }),
)(CustomDropIn);

type IProps = IInnerProps & IOuterProps;

interface IInnerProps {
  token: string;
}

interface IOuterProps {
  setDropInInstance: (dropIn: Dropin) => void;
  dropInInstance?: Dropin;
  errorMessage?: string;
}
